import { GmvTier } from 'app/graphql/generated/admin/graphql';
import {
  Breakdown,
  BreakdownDivider,
  BreakdownItem,
  BreakdownItemContent,
  Container,
} from './styles';

type Props = {
  gmvTier: GmvTier;
  amount: number;
};
export const GMVTierCard = ({ gmvTier, amount }: Props) => {
  const getGMVText = () => {
    if (gmvTier.max) {
      return ` ${new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(gmvTier.min / 100)} ≤ GMV < ${new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(gmvTier.max / 100)}`;
    }
    return `≥ ${new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(gmvTier.min / 100)}`;
  };

  return (
    <Container className="rounded-lg border">
      <Breakdown>
        <BreakdownItem>
          <BreakdownItemContent>
            <div>Current Tier</div>
            <BreakdownDivider />
            <div>Tier {gmvTier.tier}</div>
          </BreakdownItemContent>
        </BreakdownItem>
        <BreakdownItem>
          <BreakdownItemContent>
            <div>Tier Range</div>
            <BreakdownDivider />
            <div>{getGMVText()}</div>
          </BreakdownItemContent>
        </BreakdownItem>
        <BreakdownItem>
          <BreakdownItemContent>
            <div>Percentage of GMV</div>
            <BreakdownDivider />
            <div>{gmvTier.percentage}%</div>
          </BreakdownItemContent>
        </BreakdownItem>
        <BreakdownItem>
          <BreakdownItemContent>
            <div>Rye Service Fee</div>
            <BreakdownDivider />
            <div>
              {new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
              }).format(amount / 100)}
            </div>
          </BreakdownItemContent>
        </BreakdownItem>
      </Breakdown>
    </Container>
  );
};
